// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumbs__list[data-v-48efbb98]{border-top:1px dashed #e7e8f1;padding:20px 0}.breadcrumbs__item[data-v-48efbb98]{display:inline}.breadcrumbs__item--current[data-v-48efbb98]{color:#7b7d8e}.breadcrumbs__item+.breadcrumbs__item[data-v-48efbb98]:before{background:#000;content:\"\";display:inline-block;height:2px;margin:0 10px 3px;vertical-align:middle;width:2px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
